import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import BoosterProgram from 'pages/booster-program'
import BoosterProgramCreate from 'pages/booster-program/create'
import BoosterProgramDetail from 'pages/booster-program/detail'
import PTO from 'pages/pto'
import CreatePTO from 'pages/pto/create'
import PTODetailWrapper from 'pages/pto/pto-detail'
import PtoReferralProgram from 'pages/pto-referral'
import PTORewards from 'pages/pto-rewards'
import PTOV2 from 'pages/pto-v2'
import CreatePTOV2 from 'pages/pto-v2/create'
import PTOV2DetailWrapper from 'pages/pto-v2/pto-detail'
import PTOV3 from 'pages/pto-v3'
import CreatePTOV3 from 'pages/pto-v3/create'
import PTOV3Detail from 'pages/pto-v3/pto-detail'
import { PAGES } from 'routes/index'

export const ptoRoutes: RouteObject[] = [
  {
    path: PAGES.PTO,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <PTO />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_REWARDS,
    element: (
      <PrivateRoute feature={FEATURE.PTO_REWARDS}>
        <PTORewards />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_REFERRAL,
    element: (
      <PrivateRoute feature={FEATURE.PTO_REFERRAL}>
        <PtoReferralProgram />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.BOOSTER_PROGRAM,
    element: (
      <PrivateRoute feature={FEATURE.BOOSTER_PROGRAM}>
        <BoosterProgram />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.BOOSTER_PROGRAM_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.BOOSTER_PROGRAM} requireCRUD>
        <BoosterProgramCreate />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.BOOSTER_PROGRAM_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.BOOSTER_PROGRAM}>
        <BoosterProgramDetail />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_DETAIL_CODE,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <PTODetailWrapper />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.PTO} requireCRUD>
        <CreatePTO />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_V2,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <PTOV2 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_V2_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.PTO} requireCRUD>
        <CreatePTOV2 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_V2_DETAIL_CODE,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <PTOV2DetailWrapper />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_V3,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <PTOV3 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_V3_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <CreatePTOV3 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PTO_V3_DETAIL_CODE,
    element: (
      <PrivateRoute feature={FEATURE.PTO}>
        <PTOV3Detail />
      </PrivateRoute>
    ),
  },
]
